module.exports = __webpack_public_path__ + "img/fees.368356b3.png";